// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AddNewHoldingsGroupMutationVariables = Types.Exact<{
  input: Types.AugmentedCreateEntityInput;
}>;


export type AddNewHoldingsGroupMutation = { __typename?: 'Mutation', createEntity: { __typename?: 'Entity', id: string, kind: Types.EntityKind, subtype: { __typename?: 'CCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'CLTTrust', id: string, displayName: string } | { __typename?: 'CRTTrust', id: string, displayName: string } | { __typename?: 'CustodialPersonalAccount', id: string, displayName: string } | { __typename?: 'DonorAdvisedFund', id: string, displayName: string } | { __typename?: 'GPBusinessEntity', id: string, displayName: string } | { __typename?: 'GRATTrust', id: string, displayName: string } | { __typename?: 'ILITTrust', id: string, displayName: string } | { __typename?: 'IndividualPersonalAccount', id: string, displayName: string } | { __typename?: 'InsurancePersonalAccount', id: string, displayName: string } | { __typename?: 'IrrevocableTrust', id: string, displayName: string } | { __typename?: 'JointPersonalAccount', id: string, displayName: string } | { __typename?: 'LLCBusinessEntity', id: string, displayName: string } | { __typename?: 'LPBusinessEntity', id: string, displayName: string } | { __typename?: 'PrivateFoundation', id: string, displayName: string } | { __typename?: 'QPRTTrust', id: string, displayName: string } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, displayName: string } | { __typename?: 'RetirementPersonalAccount', id: string, displayName: string } | { __typename?: 'RevocableTrust', id: string, displayName: string } | { __typename?: 'SCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'SLATTrust', id: string, displayName: string } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string, displayName: string } } };

export const Operations = {
  Mutation: {
    AddNewHoldingsGroup: 'AddNewHoldingsGroup' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const AddNewHoldingsGroupDocument = gql`
    mutation AddNewHoldingsGroup($input: AugmentedCreateEntityInput!) {
  createEntity(input: $input) {
    id
    kind
    subtype {
      id
      displayName
    }
  }
}
    `;
export type AddNewHoldingsGroupMutationFn = Apollo.MutationFunction<AddNewHoldingsGroupMutation, AddNewHoldingsGroupMutationVariables>;

/**
 * __useAddNewHoldingsGroupMutation__
 *
 * To run a mutation, you first call `useAddNewHoldingsGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddNewHoldingsGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addNewHoldingsGroupMutation, { data, loading, error }] = useAddNewHoldingsGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddNewHoldingsGroupMutation(baseOptions?: Apollo.MutationHookOptions<AddNewHoldingsGroupMutation, AddNewHoldingsGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddNewHoldingsGroupMutation, AddNewHoldingsGroupMutationVariables>(AddNewHoldingsGroupDocument, options);
      }
export type AddNewHoldingsGroupMutationHookResult = ReturnType<typeof useAddNewHoldingsGroupMutation>;
export type AddNewHoldingsGroupMutationResult = Apollo.MutationResult<AddNewHoldingsGroupMutation>;
export type AddNewHoldingsGroupMutationOptions = Apollo.BaseMutationOptions<AddNewHoldingsGroupMutation, AddNewHoldingsGroupMutationVariables>;